var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"housingTypeManagement"},[_vm._m(0),_c('div',{staticClass:"case-wrap"},[_c('communityManagement',{ref:"communityManagement"})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-wrap"},[_c('div',{staticClass:"tag"}),_c('div',{staticClass:"title"},[_vm._v("小区列表")])])
}]

export { render, staticRenderFns }